import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './ActiveList.css';
import { serviceGetDoctor } from "../Services/Service";

import Table from './DataTable/DataTable';
import { CustomLoader } from "../Services/CommonLibrary"

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function DoctorList() {

    const clickhandler = name => console.log("delete", name);
    const [loading, setLoading] = useState(true);

    const [serviceData, setServiceData] = useState([]);
    var storage= JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    let programId = storage.programId;

    const nav = useNavigate();
    let accessFrom= localStorage.getItem('access');
    let limit ='';

    useEffect(() => {
        fetchProgramDetails();
    }, []);

    const fetchProgramDetails = async () => {
        if (accessFrom!='superadmin') {
            return nav('/upload');      
          }
          serviceGetDoctor()
            .then((res) => {
                console.log(res.data);
                setServiceData(res.data.data.doctor);
                setLoading(false);
            });
    }

   
    const columns = [
        {name: "#",selector: row => row.serial_number, sortable: false,grow: 1},
        {name: "Lead Doctor Name",selector: row => row.drName,sortable: true,grow: 3},
        {name: "Email",selector: row => row.email,sortable: true,grow: 4},
        {name: "Created By",selector: row => row.createdBy,sortable: true,grow: 3}
      ];
    
    return (
        <section className='projects-section'>
            <div className='row'>
                <div className="FL">
                    <div className="row align-items-center displayFlex">
                        <div className="col-md-10">
                            <h1 className="title">Lead Doctor List &nbsp;&nbsp;&nbsp;<Link className='btn btn-primary btn-edit' to={`/doctor-add`}>Add Lead Doctor</Link></h1><br />
                            {/* <h3 className="title">Total - {totalData}</h3> */}
                        </div>
                    </div>
                    <div className='table-responsive'>
                        <Table data={serviceData} column={columns} title="" click={clickhandler} />
                    </div>
                </div>
            </div>
            { loading ? <CustomLoader /> : null }
        </section>


    );
}

export default DoctorList;